import { DataModules, IDataState } from "@/store/modules/data/index";
import { ActionTree, GetterTree } from "vuex";
import { IState } from "@/store";
import { Methods } from "@/models/methods";
import { ApiPathGetter } from "@/models/api";
import { IProvisionRequest } from "@/models/provisioning";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = `api/admin/provision/requests`;
    return { admin };
  },
  singleScope: () => requestId => {
    return `$provision_request_${requestId}`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  get: ({ dispatch, getters }, { requestId, payload } = { payload: {} }) => {
    // Set default params
    payload.params = {
      with: [
        "action_logs.action",
        "actor",
        "blueprint_function",
        "client",
        "configuration",
        "hook_log",
        "order_product",
        "results",
        "scheduler_cron",
        "status"
      ].join(),
      ...payload.params
    };
    return dispatch(
      "data/get",
      {
        ...payload,
        method: Methods.GET,
        path: `${getters.apiPath().admin}/${requestId}`,
        storeModule: DataModules.PROVISIONING_REQUESTS
      },
      { root: true }
    );
  },
  openRequestModal: ({ dispatch }, requestId: IProvisionRequest["id"]) =>
    dispatch(
      "ui/open/slideModal",
      {
        config: {
          component: () =>
            import(
              "@/components/app/admin/provisioning/provisionRequestModal.vue"
            ),
          props: {
            requestId
          }
        }
      },
      { root: true }
    )
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
